<!-- Toast Messages - Positioned at root level -->
<p-toast
  data-testid="bpmn-list-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="false"
></p-toast>

<div class="p-4 flex-table-page" data-testid="bpmn-list-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "bpmn.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="bpmn-list-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'bpmn-list-engine-settings-btn'"
        type="info"
        [outlined]="true"
        [label]="'sidebar.setting.workflow_engine_settings' | translate"
        (emitOnClick)="onOpenEngineSettings()"
      ></app-button>
      <app-button
        [testId]="'bpmn-list-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      @if (canCreate()) {
        <app-status-filter
          data-testid="bpmn-list-status-filter"
          [primaryButton]="primaryButton()"
          (primaryButtonClick)="onAdd()"
        ></app-status-filter>
      }
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      data-testid="bpmn-list-table"
      [dataSource]="bpmnProcesses()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [totalRecords]="totalRecords()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
    <!-- Custom Template for Date columns -->
    <ng-template
      #customTemplate
      let-value
      let-rowData="rowData"
      let-column="column"
    >
      @if (column && column.template === "dateTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatDateTime(value) }}
        </span>
      }
    </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status let-rowData="rowData">
      <div class="flex items-center justify-center gap-1">
        <p-tag
          [attr.data-testid]="'bpmn-list-status-tag-' + rowData.id"
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="
            status === 1
              ? ('bpmn.status.deployed' | translate)
              : ('bpmn.status.not_deployed' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-1 justify-center flex-wrap">
        @if (canRead()) {
          <app-button
            [testId]="'bpmn-list-action-view-' + rowData.id"
            class="action-view"
            [label]="'bpmn.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }

        @if (canUpdate()) {
          <app-button
            [testId]="'bpmn-list-action-edit-' + rowData.id"
            class="action-edit"
            [label]="'bpmn.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        }

        @if (canApprove()) {
          <app-button
            [testId]="'bpmn-list-action-deploy-' + rowData.id"
            class="action-deploy"
            [label]="'bpmn.actions.deploy' | translate"
            type="action"
            [disabled]="isDeployDisabled(rowData.status)"
            (emitOnClick)="onDeploy(rowData)"
          ></app-button>
        }

        @if (canDelete()) {
          <app-button
            [testId]="'bpmn-list-action-delete-' + rowData.id"
            class="action-delete"
            [label]="'bpmn.actions.delete' | translate"
            type="action"
            [disabled]="isDeleteDisabled(rowData.status)"
            (emitOnClick)="onDelete(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'bpmn-list-confirmation-dialog'"
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
